export default {
    'export': 'Export',
    'export-as-excel': 'Export as excel file',
    'print-materials-tree': 'Print tree items',
    warehouse: 'Warehouse',
    'material-name-or-no': 'Item ID or name',
    'add': 'Add',
    'please-select-material': 'Please choose an item',
}